import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import global_en from "./locales/en/global.json";
import global_ro from "./locales/ro/global.json";
import global_fr from "./locales/fr/global.json";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, LANGUAGE_DETECTION_OPTIONS } from "./config/languages";

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    whitelist: SUPPORTED_LANGUAGES,

    detection: LANGUAGE_DETECTION_OPTIONS,

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        global: global_en,
      },
      ro: {
        global: global_ro,
      },
      fr: {
        global: global_fr,
      },
    },
  });

export default i18n;
